import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const ParagraphForgotPassword = styled('p')(
    ({ theme }) => `
font-size: 14;
line-height: 1.5;
color: ${theme.palette.common.black};
cursor: pointer;

&:hover,
&:focus {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
}
`
);

export const LinkStyled = styled(Link)(
    ({ theme }) => `
font-size: 14;
line-height: 1.5;
color: ${theme.palette.common.black};
cursor: pointer;

&:hover,
&:focus {
    color: ${theme.palette.primary.main};
    text-decoration: underline;
}
`
);